const GetCazaAlumnosAdmin = async (idCaza: string, idConjunt?: number | null) => {
    try {
        const conjuntParam = idConjunt != null ? `?idConjunt=${idConjunt}` : '';
        const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/caza/${idCaza}/admin/alumnos${conjuntParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (Array.isArray(data)) {
            return data;
        } else if (data && Array.isArray(data.json)) {
            // Sometimes backend returns { "json": [...] } or similar?
            // Actually, looking at get_caza, it returns the JSON directly.
            // But if it returns error object:
            console.error("Received non-array data:", data);
            return [];
        }
        return [];
    } catch (error) {
        console.error('Error fetching students:', error);
        return [];
    }
}

export { GetCazaAlumnosAdmin };
